// import React, { useEffect, useRef, useState, useCallback } from "react"
// import "./index.css"
// import { onDownloadReportPdf } from "./DownloadReport"
// import zithasLogo from "../../../assets/images/zithasLogo.png"
// import footerDesign from "../../../assets/images/appointment_footer.png"
// import { Modal } from "reactstrap"
// import { CKEditor } from "@ckeditor/ckeditor5-react"
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
// import { dummyContent } from "./dummySeoReportData"
// import { fetchNodeData } from "utils/common-fetchData"
// import secureLocalStorage from "react-secure-storage"
// import Swal from "sweetalert2"

// // ─── Constants ────────────────────────────────────────────────────────────────  ─
// const PAGE_HEIGHT = 800 // must match .page-content-letter rendered height
// const CONTENT_WIDTH = 684 // must match .page-content-letter rendered width
// const DEBOUNCE_MS = 600 // wait this long after last keystroke before paginating

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// /** Create a new element copying tag + className + style from source */
// const cloneShell = node => {
//   const el = document.createElement(node.tagName || "SPAN")
//   if (node.className) el.className = node.className
//   const style = node.getAttribute && node.getAttribute("style")
//   if (style) el.setAttribute("style", style)
//   return el
// }

// /**
//  * Binary-search split of a leaf element's text across pages.
//  *
//  * Instead of probing word-by-word (O(n) DOM ops), we binary-search
//  * for the last word index that still fits → O(log n) DOM ops per paragraph.
//  */
// const splitLeafByBinarySearch = (node, page, commitPage) => {
//   const words = (node.textContent || "").trim().split(/\s+/).filter(Boolean)
//   if (!words.length) return

//   let start = 0

//   while (start < words.length) {
//     // Check: does even a single word overflow on an empty page?
//     const probe = cloneShell(node)
//     probe.textContent = words[start]
//     page.appendChild(probe)
//     const oneWordFits = page.scrollHeight <= PAGE_HEIGHT
//     page.removeChild(probe)

//     if (!oneWordFits) {
//       // Word alone overflows (extremely long word / tiny PAGE_HEIGHT)
//       commitPage()
//       start++
//       continue
//     }

//     // Binary search: find the largest `end` where words[start..end] fit
//     let lo = start
//     let hi = words.length - 1
//     let best = start

//     while (lo <= hi) {
//       const mid = (lo + hi) >>> 1
//       const probe = cloneShell(node)
//       probe.textContent = words.slice(start, mid + 1).join(" ")
//       page.appendChild(probe)
//       const fits = page.scrollHeight <= PAGE_HEIGHT
//       page.removeChild(probe)

//       if (fits) {
//         best = mid
//         lo = mid + 1
//       } else {
//         hi = mid - 1
//       }
//     }

//     // Commit the fitting slice as a real element
//     const commitEl = cloneShell(node)
//     commitEl.textContent = words.slice(start, best + 1).join(" ")
//     page.appendChild(commitEl)

//     start = best + 1

//     if (start < words.length) commitPage()
//   }
// }

// /**
//  * Recursively place a DOM node onto the current page.
//  */
// const addNode = (node, page, commitPage) => {
//   if (node.nodeType === Node.TEXT_NODE) {
//     if (!node.textContent.trim()) return
//     const span = document.createElement("span")
//     span.textContent = node.textContent
//     addNode(span, page, commitPage)
//     return
//   }

//   if (node.nodeType !== Node.ELEMENT_NODE) return

//   const clone = node.cloneNode(true)
//   page.appendChild(clone)
//   if (page.scrollHeight <= PAGE_HEIGHT) return // fits ✓
//   page.removeChild(clone)

//   const hasChildElements = node.children && node.children.length > 0

//   if (!hasChildElements) {
//     splitLeafByBinarySearch(node, page, commitPage)
//   } else {
//     // Try on a fresh page first
//     if (page.innerHTML.trim()) {
//       commitPage()
//       const freshClone = node.cloneNode(true)
//       page.appendChild(freshClone)
//       if (page.scrollHeight <= PAGE_HEIGHT) return // fits on fresh page ✓
//       page.removeChild(freshClone)
//     }
//     // Still too tall — recurse into children
//     Array.from(node.childNodes).forEach(child =>
//       addNode(child, page, commitPage)
//     )
//   }
// }

// /**
//  * Async paginator — yields to the browser between batches of top-level
//  * nodes so the UI thread never freezes on large content.
//  */
// const paginateAsync = (html, container, onDone, cancelRef) => {
//   container.innerHTML = ""

//   const finalPages = []
//   const page = document.createElement("div")
//   container.appendChild(page)

//   const commitPage = () => {
//     const trimmed = page.innerHTML.trim()
//     if (trimmed) finalPages.push(trimmed)
//     page.innerHTML = ""
//   }

//   const temp = document.createElement("div")
//   temp.innerHTML = html
//   const topNodes = Array.from(temp.childNodes)

//   let index = 0
//   const BATCH = 5 // top-level nodes processed per frame

//   const processNext = () => {
//     if (cancelRef.current) return // stale run — abort

//     const end = Math.min(index + BATCH, topNodes.length)
//     for (let i = index; i < end; i++) {
//       addNode(topNodes[i], page, commitPage)
//     }
//     index = end

//     if (index < topNodes.length) {
//       setTimeout(processNext, 0) // yield to browser, then continue
//     } else {
//       if (page.innerHTML.trim()) finalPages.push(page.innerHTML)
//       onDone(finalPages)
//     }
//   }

//   processNext()
// }

// // ─── Component ────────────────────────────────────────────────────────────────

// export default function AppointmentPreview({ previewModal, setPreviewModal, staff }) {
//   const [loading, setLoading] = useState(false)
//   const [pages, setPages] = useState([])
//   const [paginating, setPaginating] = useState(false)

//   const hiddenRef = useRef()
//   const reportRef = useRef()
//   const debounceTimer = useRef(null)
//   const cancelRef = useRef(false)

//   const [content, setContent] = useState("")

//   const [template, setTemplate] = useState(null)
//   const [templates, setTemplates] = useState([])
//   const getTemplates = async () => {
//     try {
//       const response = await fetchNodeData(
//         setLoading,
//         "staffTemplate",
//         secureLocalStorage?.getItem("auth_token")
//       )
//       console.log("response", response)
//       setTemplates(response.data)
//     } catch (err) {
//       console.error("Error fetching contract templates:", err)
//       Swal.fire({
//         icon: "error",
//         text: "Failed to fetch contract templates",
//         showConfirmButton: true,
//       })
//     }
//   }

//   useEffect(() => {
//     getTemplates()
//   }, [])

//   const schedulePagination = useCallback(html => {
//     // Cancel any in-progress or pending run
//     cancelRef.current = true
//     clearTimeout(debounceTimer.current)

//     debounceTimer.current = setTimeout(() => {
//       if (!hiddenRef.current) return
//       cancelRef.current = false
//       setPaginating(true)

//       paginateAsync(
//         html,
//         hiddenRef.current,
//         result => {
//           if (cancelRef.current) return
//           setPages(result)
//           setPaginating(false)
//         },
//         cancelRef
//       )
//     }, DEBOUNCE_MS)
//   }, [])

//   useEffect(() => {
//     schedulePagination(content)
//     return () => {
//       clearTimeout(debounceTimer.current)
//       cancelRef.current = true
//     }
//   }, [content, schedulePagination])

//   // useEffect(() => {
//   //   if (previewModal && !content) setContent(dummyContent)
//   // }, [previewModal])

//   useEffect(() => {
//     if (templates.length && template)
//       setContent(templates.find(item => item.id == template)?.description)
//   }, [templates, template])

//   return (
//     <Modal isOpen={previewModal} centered className="modal-fullscreen">
//       <div className="modal-header">
//         <div className="d-flex align-items-center gap-4">
//           <h5 className="modal-title mb-0 mt-0">
//             Appointment Letter - Jack Smith
//           </h5>
//           <div>
//             <select
//               value={template}
//               onChange={e => setTemplate(e.target.value)}
//               className="form-select"
//             >
//               <option value="">Select Template</option>

//               {templates.map(item => (
//                 <option key={item.id} value={item.id}>
//                   {item.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         <div>
//           <button
//             onClick={() =>
//               onDownloadReportPdf(setLoading, reportRef, "Appointment_Letter")
//             }
//             className="btn btn-success me-3"
//             disabled={loading || paginating}
//           >
//             <i
//               className={`fas fa-${
//                 loading ? "spinner bx-spin" : "download"
//               } me-2`}
//             ></i>
//             {paginating || loading ? "Processing..." : "Download"}
//           </button>
//           <button
//             type="button"
//             onClick={() => setPreviewModal(false)}
//             className="btn-modal-close"
//           >
//             <span className="btn-modal-span">&times;</span>
//           </button>
//         </div>
//       </div>

//       <div className="modal-body preview-body">
//         <div className="row">
//           <div className="col-md-5">
//             {/* Editor */}
//             <div className="p-4 bg-white mb-5 ">
//               <CKEditor
//                 editor={ClassicEditor}
//                 data={content}
//                 onChange={(_event, editor) => setContent(editor.getData())}
//               />
//             </div>
//           </div>

//           <div
//             className="col-md-7 overflow-auto position-relative"
//             style={{ height: "80vh" }}
//           >
//             {/* Pages */}
//             <div ref={reportRef}>
//               {/* Loader */}
//               {paginating && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     inset: 0,
//                     background: "rgba(255,255,255,0.65)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     zIndex: 10,
//                     minHeight: 200,
//                     borderRadius: 4,
//                   }}
//                 >
//                   <i className="fas fa-spinner bx-spin fa-2x text-secondary" />
//                 </div>
//               )}

//               {pages.map((pageHtml, i) => (
//                 <div className="a4-page" key={i}>

//                   <div className="page-header pt-3 ps-4">
//                     <img
//                       src={zithasLogo}
//                       alt=""
//                       className="bg-white"
//                       style={{ height: "55px" }}
//                     />
//                   </div>

//                   {/* CONTENT */}
//                   <div
//                     className="page-content-letter ckeditor-content"
//                     dangerouslySetInnerHTML={{ __html: pageHtml }}
//                   />
//                   {/* FOOTER */}
//                   <div className="page-footer">
//                     <img src={footerDesign} alt="" className="w-100" />
//                     {/* <div className="footer-accent-line"></div> */}
//                     <div className="footer-body">
//                       <div className="footer-info">
//                         <span>
//                           {" "}
//                           <i className="fa fa-envelope me-1"></i> hr@zithas.com
//                         </span>
//                         <span>
//                           {" "}
//                           <i className="fa fa-globe me-1"></i> www.zithas.com
//                         </span>
//                         <span>
//                           {" "}
//                           <i className="fa fa-phone me-1"></i> +91 265 000 0000
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/*
//           Hidden measurement container.
//           ⚠️ Width MUST match the actual rendered width of .page-content-letter.
//         */}
//         <div
//           ref={hiddenRef}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             visibility: "hidden",
//             pointerEvents: "none",
//             width: `${CONTENT_WIDTH}px`,
//             overflow: "visible",
//           }}
//         />
//       </div>
//     </Modal>
//   )
// }

import React, { useEffect, useRef, useState, useCallback } from "react"
import "./index.css"
import { onDownloadReportPdf } from "./DownloadReport"
import zithasLogo from "../../../assets/images/zithasLogo.png"
import footerDesign from "../../../assets/images/appointment_footer.png"
import { Modal } from "reactstrap"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { fetchNodeData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import Swal from "sweetalert2"

// ─── Constants ────────────────────────────────────────────────────────────────
const PAGE_HEIGHT = 800
const CONTENT_WIDTH = 684
const DEBOUNCE_MS = 600

// ─── Dynamic Field Replacer ───────────────────────────────────────────────────

/**
 * Builds the field→value map from a staff object and replaces all
 * {$field} placeholders in the HTML string with real values.
 *
 * Supported tokens (matches image + template):
 *   $emp_name  $emp_id  $basic_salary  $dearness_allowance  $house_rent
 *   $conveyance  $address_1  $address_2  $city  $state  $country  $pincode
 *   $company_name  $shift_start_and_end_time  $shift_start  $shift_end
 *   $total_salary  $department  $position  $designation  $join_date
 *   $date_of_resignation
 */
const replaceDynamicFields = (html, staff) => {
  if (!html || !staff) return html

  // Calculate total salary (sum all earning components)
  const toNum = v => parseFloat(v) || 0
  const totalSalary = (
    toNum(staff.basic_pay) +
    toNum(staff.dearness_allowance) +
    toNum(staff.house_rent_allowance) +
    toNum(staff.conveyance_allowance) +
    toNum(staff.medical_allowance)
  ).toFixed(2)

  // Derive shift display from staff shift data (adjust field names as needed)
  const shiftStart = staff.shift_start || staff.shift?.start_time || "09:00 AM"
  const shiftEnd = staff.shift_end || staff.shift?.end_time || "06:00 PM"
  const shiftRange = `${shiftStart} to ${shiftEnd}`

  // Format a date string to DD-MM-YYYY for readability
  const fmtDate = raw => {
    if (!raw) return ""
    const d = new Date(raw)
    if (isNaN(d)) return raw
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
  }

  const fieldMap = {
    // Identity
    $emp_name: staff.name || "",
    $emp_id: staff.employee_code || "",
    $designation: staff.designation || "",
    $position: staff.designation || "",
    $department: staff.department_name || staff.department || "",
    $company_name: staff.company_name || "",

    // Dates
    $join_date: fmtDate(staff.date_of_joining),
    $date_of_resignation: fmtDate(staff.date_of_resignation),

    // Address
    $address_1: staff.address || "",
    $address_2: staff.address_line_2 || "",
    $city: staff.city_name || staff.city || "",
    $state: staff.state_name || staff.state || "",
    $country: staff.country_name || staff.country || "",
    $pincode: staff.zip_code || "",

    // Compensation
    $basic_salary: staff.basic_pay || "0",
    $dearness_allowance: staff.dearness_allowance || "0",
    $house_rent: staff.house_rent_allowance || "0",
    $conveyance: staff.conveyance_allowance || "0",
    $total_salary: totalSalary,

    // Shift
    $shift_start_and_end_time: shiftRange,
    $shift_start: shiftStart,
    $shift_end: shiftEnd,
  }

  // Replace every $token found in the HTML
  return html.replace(/\$([a-z_]+)/gi, (match, token) => {
    const key = `$${token}`
    return Object.prototype.hasOwnProperty.call(fieldMap, key)
      ? fieldMap[key]
      : match // leave unknown tokens untouched
  })
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

const cloneShell = node => {
  const el = document.createElement(node.tagName || "SPAN")
  if (node.className) el.className = node.className
  const style = node.getAttribute && node.getAttribute("style")
  if (style) el.setAttribute("style", style)
  return el
}

const splitLeafByBinarySearch = (node, page, commitPage) => {
  const words = (node.textContent || "").trim().split(/\s+/).filter(Boolean)
  if (!words.length) return

  let start = 0

  while (start < words.length) {
    const probe = cloneShell(node)
    probe.textContent = words[start]
    page.appendChild(probe)
    const oneWordFits = page.scrollHeight <= PAGE_HEIGHT
    page.removeChild(probe)

    if (!oneWordFits) {
      commitPage()
      start++
      continue
    }

    let lo = start,
      hi = words.length - 1,
      best = start

    while (lo <= hi) {
      const mid = (lo + hi) >>> 1
      const probe = cloneShell(node)
      probe.textContent = words.slice(start, mid + 1).join(" ")
      page.appendChild(probe)
      const fits = page.scrollHeight <= PAGE_HEIGHT
      page.removeChild(probe)
      if (fits) {
        best = mid
        lo = mid + 1
      } else {
        hi = mid - 1
      }
    }

    const commitEl = cloneShell(node)
    commitEl.textContent = words.slice(start, best + 1).join(" ")
    page.appendChild(commitEl)
    start = best + 1
    if (start < words.length) commitPage()
  }
}

const addNode = (node, page, commitPage) => {
  if (node.nodeType === Node.TEXT_NODE) {
    if (!node.textContent.trim()) return
    const span = document.createElement("span")
    span.textContent = node.textContent
    addNode(span, page, commitPage)
    return
  }
  if (node.nodeType !== Node.ELEMENT_NODE) return

  const clone = node.cloneNode(true)
  page.appendChild(clone)
  if (page.scrollHeight <= PAGE_HEIGHT) return
  page.removeChild(clone)

  const hasChildElements = node.children && node.children.length > 0

  if (!hasChildElements) {
    splitLeafByBinarySearch(node, page, commitPage)
  } else {
    if (page.innerHTML.trim()) {
      commitPage()
      const freshClone = node.cloneNode(true)
      page.appendChild(freshClone)
      if (page.scrollHeight <= PAGE_HEIGHT) return
      page.removeChild(freshClone)
    }
    Array.from(node.childNodes).forEach(child =>
      addNode(child, page, commitPage)
    )
  }
}

const paginateAsync = (html, container, onDone, cancelRef) => {
  container.innerHTML = ""
  const finalPages = []
  const page = document.createElement("div")
  container.appendChild(page)

  const commitPage = () => {
    const trimmed = page.innerHTML.trim()
    if (trimmed) finalPages.push(trimmed)
    page.innerHTML = ""
  }

  const temp = document.createElement("div")
  temp.innerHTML = html
  const topNodes = Array.from(temp.childNodes)

  let index = 0
  const BATCH = 5

  const processNext = () => {
    if (cancelRef.current) return
    const end = Math.min(index + BATCH, topNodes.length)
    for (let i = index; i < end; i++) addNode(topNodes[i], page, commitPage)
    index = end
    if (index < topNodes.length) {
      setTimeout(processNext, 0)
    } else {
      if (page.innerHTML.trim()) finalPages.push(page.innerHTML)
      onDone(finalPages)
    }
  }

  processNext()
}

// ─── Component ────────────────────────────────────────────────────────────────

export default function AppointmentPreview({
  previewModal,
  setPreviewModal,
  staff,
  letterTemplate,
}) {
  const [loading, setLoading] = useState(false)
  const [pages, setPages] = useState([])
  const [paginating, setPaginating] = useState(false)
  const [content, setContent] = useState("")
  const [docType, setDocType] = useState("designed")

  // const [template, setTemplate] = useState(null)
  // const [templates, setTemplates] = useState([])

  const hiddenRef = useRef()
  const reportRef = useRef()
  const debounceTimer = useRef(null)
  const cancelRef = useRef(false)

  // ── Fetch templates ──────────────────────────────────────────────────────
  // const getTemplates = async () => {
  //   try {
  //     const response = await fetchNodeData(
  //       setLoading,
  //       "staffTemplate",
  //       secureLocalStorage?.getItem("auth_token")
  //     )
  //     setTemplates(response.data)
  //   } catch (err) {
  //     console.error("Error fetching contract templates:", err)
  //     Swal.fire({
  //       icon: "error",
  //       text: "Failed to fetch contract templates",
  //       showConfirmButton: true,
  //     })
  //   }
  // }

  // useEffect(() => {
  //   getTemplates()
  // }, [])

  // ── When template selection changes, inject staff values ─────────────────
  useEffect(() => {
    if (letterTemplate?.new_template && staff) {
      const rawHtml = letterTemplate?.new_template
      // const filledHtml = replaceDynamicFields(rawHtml, staff)
      setContent(rawHtml)
    }
  }, [letterTemplate, staff])

  // ── Pagination ───────────────────────────────────────────────────────────
  const schedulePagination = useCallback(html => {
    cancelRef.current = true
    clearTimeout(debounceTimer.current)

    debounceTimer.current = setTimeout(() => {
      if (!hiddenRef.current) return
      cancelRef.current = false
      setPaginating(true)

      paginateAsync(
        html,
        hiddenRef.current,
        result => {
          if (cancelRef.current) return
          setPages(result)
          setPaginating(false)
        },
        cancelRef
      )
    }, DEBOUNCE_MS)
  }, [])

  useEffect(() => {
    schedulePagination(content)
    return () => {
      clearTimeout(debounceTimer.current)
      cancelRef.current = true
    }
  }, [content, schedulePagination])

  // ── Handle manual editor changes (re-apply field replacement on the fly) ─
  const handleEditorChange = (_event, editor) => {
    // Re-replace in case the user manually typed a token
    const raw = editor.getData()
    const filled = replaceDynamicFields(raw, staff)
    setContent(filled)
  }

  return (
    <Modal isOpen={previewModal} centered className="modal-fullscreen">
      <div className="modal-header">
        <div className="d-flex align-items-center gap-4">
          <h5 className="modal-title mb-0 mt-0">
            Appointment Letter – {staff?.name || "Employee"}
          </h5>
          <div>
            {/* <select
              value={template}
              onChange={e => setTemplate(e.target.value)}
              className="form-select"
            >
              <option value="">Select Template</option>
              {templates.map(item => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select> */}
          </div>
        </div>

        <div className="d-flex gap-3 align-items-center">
          <div>
            <select
              value={docType}
              onChange={e => setDocType(e.target.value)}
              className="form-select"
            >
              <option value="blank">Blank</option>
              <option value="designed">Designed</option>
            </select>
          </div>

          <button
            onClick={() =>
              onDownloadReportPdf(setLoading, reportRef, "Appointment_Letter")
            }
            className="btn btn-success me-3"
            disabled={loading || paginating}
          >
            <i
              className={`fas fa-${
                loading ? "spinner bx-spin" : "download"
              } me-2`}
            ></i>
            {paginating || loading ? "Processing..." : "Download"}
          </button>
          <button
            type="button"
            onClick={() => setPreviewModal(false)}
            className="btn-modal-close"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
      </div>

      <div className="modal-body preview-body">
        <div className="row">
          {/* ── Editor ── */}
          <div className="col-md-5">
            <div className="p-4 bg-white mb-5">
              <CKEditor
                editor={ClassicEditor}
                data={content}
                onChange={handleEditorChange}
              />
            </div>
          </div>

          {/* ── Pages Preview ── */}
          <div
            className="col-md-7 overflow-auto position-relative"
            style={{ height: "80vh" }}
          >
            <div ref={reportRef}>
              {paginating && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(255,255,255,0.65)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 10,
                    minHeight: 200,
                    borderRadius: 4,
                  }}
                >
                  <i className="fas fa-spinner bx-spin fa-2x text-secondary" />
                </div>
              )}

              {pages.map((pageHtml, i) => (
                <div className="a4-page" key={i}>
                  {docType === "designed" && (
                    <div className="page-header pt-3 ps-4">
                      <img
                        src={zithasLogo}
                        alt=""
                        className="bg-white"
                        style={{ height: "55px" }}
                      />
                    </div>
                  )}

                  <div
                    className="page-content-letter ckeditor-content"
                    dangerouslySetInnerHTML={{ __html: pageHtml }}
                  />

                  {docType === "designed" && (
                    <div className="page-footer">
                      <img src={footerDesign} alt="" className="w-100" />
                      <div className="footer-body">
                        <div className="footer-info">
                          <span>
                            <i className="fa fa-envelope me-1"></i>{" "}
                            hr@zithas.com
                          </span>
                          <span>
                            <i className="fa fa-globe me-1"></i> www.zithas.com
                          </span>
                          <span>
                            <i className="fa fa-phone me-1"></i> +91 265 000
                            0000
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Hidden measurement container */}
        <div
          ref={hiddenRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            visibility: "hidden",
            pointerEvents: "none",
            width: `${CONTENT_WIDTH}px`,
            overflow: "visible",
          }}
        />
      </div>
    </Modal>
  )
}
